import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "executioncontext"
    }}>{`ExecutionContext`}</h1>
    <p>{`This object is passed to the callback of `}<inlineCode parentName="p">{`core.executeAsModal`}</inlineCode>{` for modality related APIs`}</p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "hostcontrol"
    }}>{`hostControl`}</h3>
    <p>{`• `}<strong parentName="p">{`hostControl`}</strong>{`: `}<em parentName="p">{`object`}</em></p>
    <p>{`Use the methods in here to control Photoshop state`}</p>
    <h4 {...{
      "id": "type-declaration"
    }}>{`Type declaration`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`resumeHistory`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`(`}<inlineCode parentName="td">{`suspensionID`}</inlineCode>{`: `}<em parentName="td">{`number`}</em>{`) => `}<em parentName="td">{`void`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Call to resume history on a target document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`suspendHistory`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`(`}<inlineCode parentName="td">{`info`}</inlineCode>{`: { `}<inlineCode parentName="td">{`historyStateInfo`}</inlineCode>{`: `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/interfaces/historystateinfo/"
            }}><em parentName="a">{`HistoryStateInfo`}</em></a>{`  }) => `}<em parentName="td">{`Promise`}</em>{`<number`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Call to suspend history on a target document, returns the suspension ID which can be used for resumeHistory`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "iscancelled"
    }}>{`isCancelled`}</h3>
    <p>{`• `}<strong parentName="p">{`isCancelled`}</strong>{`: `}<em parentName="p">{`boolean`}</em></p>
    <p>{`True if user has cancelled the modal interaction.`}</p>
    <p>{`User can cancel by hitting the Escape key, or by pressing the "Cancel" button in the progress bar.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "oncancel"
    }}>{`onCancel`}</h3>
    <p>{`• `}<strong parentName="p">{`onCancel`}</strong>{`: `}<em parentName="p">{`void`}</em></p>
    <p>{`If assigned a method, it will be called when user cancels the modal interaction.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "reportprogress"
    }}>{`reportProgress`}</h3>
    <p>{`• `}<strong parentName="p">{`reportProgress`}</strong>{`: `}<em parentName="p">{`void`}</em></p>
    <p>{`Call this to customize the progress bar.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      